import { useMemo } from 'react';

import { useAppSelector } from '@config/react-redux/hooks';
import {
    selectClassGroupFilterClassroomSelectedId,
    selectClassGroupFilterGroupSelectedId
} from '@containers/class-group-filters/class-group-filters-slice';

export type ClassContext = {
    classId: string | null
    groupId: string | null
};

const toId = (id: number | null) => (id === null ? null : id.toString());

// The selected class and group, sent with every event.
export const useClassContext = (): ClassContext => {
    const classroomId = useAppSelector(selectClassGroupFilterClassroomSelectedId);
    const groupId = useAppSelector(selectClassGroupFilterGroupSelectedId);

    return useMemo(() => ({
        classId: toId(classroomId),
        groupId: toId(groupId)
    }), [classroomId, groupId]);
};
